<template>
  <footer v-if="visible" class="sf">
    <nav class="sf__nav" aria-label="Legal">
      <router-link to="/terms">Terms</router-link>
      <a href="https://www.belowmsrp.com/privacy" target="_blank" rel="noopener">Privacy<span class="sr-only"> (opens in a new tab)</span></a>
      <router-link to="/accessibility">Accessibility</router-link>
    </nav>
    <p class="sf__copy">&copy; {{ year }} Below MSRP. All vehicle makes, models and logos belong to their respective owners.</p>
  </footer>
</template>

<script>
// One footer for every customer page (admin, the login/onboarding flow and the
// bare Build Your Car wizard have their own chrome and are skipped).
const HIDDEN_PREFIXES = ["/admin", "/login", "/register", "/get-started", "/build-your-car", "/terms", "/forgot-password", "/reset-password"];

export default {
  name: "SiteFooter",
  computed: {
    year() {
      return new Date().getFullYear();
    },
    visible() {
      const path = this.$route.path;
      return !HIDDEN_PREFIXES.some((p) => path === p || path.startsWith(p + "/"));
    },
  },
};
</script>

<style scoped>
.sf {
  /* bottom padding clears the fixed mobile tab bar */
  padding: 24px 16px 96px;
  background: #08101b;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
}
@media (min-width: 768px) {
  .sf {
    padding-bottom: 28px;
  }
}
.sf__nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px 8px;
}
.sf__nav a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 12px;
  color: #ffffff;
  text-decoration: underline;
  text-underline-offset: 3px;
}
.sf__copy {
  margin: 4px auto 0;
  max-width: 640px;
  color: rgba(255, 255, 255, 0.78);
  line-height: 1.5;
}
</style>
